/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadCashBankDetails(paymentDetails) {
  return await api
    .post(`/org/getbankaccount`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createCashBankDetails(paymentDetails) {
  return await api
    .post(`/org/addbankaccount`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function updateCashBankDetails(paymentDetails) {
  return await api
    .put(`/org/updatebankaccount`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deleteCashBankDetails(paymentDetails) {
  return await api
    .post(`/org/deletebankaccount`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadCashBankTotalDetails(paymentDetails) {
  return await api
    .post(`/org/gettotalbalance`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalCashBankTransactionDetails(paymentDetails) {
  return await api
    .post(`/org/getdashboardtransactiondata`, paymentDetails)
    .then((response) => response.data.data)
    .catch((error) => Promise.reject(error));
}

export async function loadCashInHandTransactionDetails(paymentDetails) {
  return await api
    .post(`/org/getcashinhanddata`, paymentDetails)
    .then((response) => response.data.data)
    .catch((error) => Promise.reject(error));
}

export async function loadCashInHandDetails(paymentDetails) {
  return await api
    .post(`/org/getcashinhand`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadAccountTransactionDetails(paymentDetails) {
  return await api
    .post(`/org/getaccounttransactiondata`, paymentDetails)
    .then((response) => response.data && response.data.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadCashBankDetails,
  loadCashBankTotalDetails,
  createCashBankDetails,
  loadRecordsMetaData,
  updateCashBankDetails,
  deleteCashBankDetails,
  loadTotalCashBankTransactionDetails,
  loadCashInHandTransactionDetails,
  loadCashInHandDetails,
  loadAccountTransactionDetails,
};

export default remotes;
